import React, { Component } from "react";
import { Button } from "react-bootstrap";
import signalDispatcher from "../utils/signalDispatcher";
import cart from "../models/cart-model";

interface TimerState {
    time: number;
    timeLabel: string;
    timeAlertLimit: number;
    translations?: Record<string, any>;
}

class TimerBox extends Component<{}, TimerState> {
    constructor(props: TimerState) {
        super(props);
        let translations = JSON.parse(localStorage.getItem('translations') || '[]');
        this.state = { 
            time: 0, 
            timeLabel: '',
            timeAlertLimit: 10,
            translations: translations
        };
    }

    componentDidMount(): void {
        const timerLabel = this.state.translations?.filter((item: any) => item.setting_name === 'TIME_LEFT')[0]?.setting_value_text || 'Time left in cart';
        this.setState({timeLabel: timerLabel});
        this.initializeTimer();

        signalDispatcher.on('addToCart', (newCart: cart) => {
            this.initializeTimer();
        });
    }

    private initializeTimer() {
        const cartData = localStorage.getItem('cart');
        let expiryTime = 0;
        if (cartData) {
            const cart = JSON.parse(cartData);
            if (cart && cart.events && cart.events.length > 0) {
                const storedExpiryTime = localStorage.getItem('cartExpiryTime');
                if (!storedExpiryTime) {
                    //expiryTime = 600;
                    //localStorage.setItem('cartExpiryTime', expiryTime.toString());
                    //this.setState({ time: expiryTime });
                } else {
                    expiryTime = parseInt(storedExpiryTime);
                    if (expiryTime > 0) {
                        this.setState({ time: expiryTime });
                    } else {
                        this.setState({ time: 0 });
                    }
                }
            }
            else {
                this.setState({ time: 0 });
            }
            //Start timer
            if (cart && cart.events && cart.events.length > 0 && (this.state.time > 0 || expiryTime > 0)) {
                const timer = setInterval(() => {
                    signalDispatcher.on('resetCart', () => {
                        clearInterval(timer);
                        this.setState({ time: 0 });
                    });
                    if (this.state.time > 0) {
                        this.setState({ time: this.state.time - 1 });
                        localStorage.setItem('cartExpiryTime', (this.state.time - 1).toString());
                    }
                    else {
                        clearInterval(timer);
                        localStorage.removeItem('cart');
                        localStorage.removeItem('uuid');
                        localStorage.removeItem('cartExpiryTime');
                        this.navigatePage('/');
                    }
                }, 1000);
            }    
        }
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private formatTime(seconds: number): string {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    }

    render() {
        return (
            <>
                {this.state.time > 0 &&
                    <Button className={this.state.time < this.state.timeAlertLimit ? 'oc-menu-button alert' : 'oc-menu-button active' } onClick={() => this.navigatePage('/cart')}>
                        {this.state.timeLabel}: {this.formatTime(this.state.time)}
                    </Button>
                }
            </>
        );
    }
}

export default TimerBox;